import { useRef } from 'react';

// machproJsCssBabelPlugin.js中，遍历所有语句找到 init 调用和默认导出
// 如果找到了 init 调用且没有默认导出，则自动创建初始化函数
// 新增包装函数
// function _m2hInitStore_() {
//   init(xxxx); // 或原来的 addModel() 调用
// }
// // 新增命名导出
// export const m2hInitStore = _m2hInitStore_;
//
// // 如果没有默认导出，还会添加
// export default _m2hInitStore_;

const useStoreInit = (storeIniters) => {
  const storeInited = useRef(false);

  if (!storeInited.current && globalThis.__MACH_PRO_STORE__ && globalThis.__MACH_PRO_STORE__.store) {
    globalThis.__MACH_PRO_STORE__.store.inited = false;
    storeIniters.forEach((initer) => {
      initer && (typeof initer === 'function') && initer();
    });
    storeInited.current = true; // 确保只初始化一次
  }
};

export default useStoreInit;
